import React from 'react'
import aboutZombie from '../../images/AboutZombie.png'
import aboutZombie2 from '../../images/AboutZombie2.png'
import { 
  AboutContainer, 
  AboutSectionBg, 
  AboutWrapper,
  AboutRow, 
  TextWrapper, 
  ImgWrap, 
  Img, 
  Subtitle,
  Heading,
  BulletWrapper,
  Bullet } from './AboutElements'

const AboutSection = () => {
  return (
    <>
      <AboutContainer id="about">
        <AboutSectionBg />
        <AboutWrapper>
          <AboutRow>
            <TextWrapper>
              <Heading>What Are Bit Monsters?</Heading>
              <Subtitle>In the year 6666, the world is on the brink of collapse. 
                        Tensions between the two global powers spill over, and the Atomicans war arrives.
              </Subtitle>
              <Subtitle>The glow from the first bombs light up the Halloween sky. 
                The survivors of the initial blast are left disfigured in their costumes. 
                Humanity is lost, and the Bit Monsters rise from the ashes as evolutions next derivative.
                </Subtitle>
            </TextWrapper>
            <ImgWrap>
              <Img src={aboutZombie} />
            </ImgWrap>
          </AboutRow>
          <AboutRow>
            <ImgWrap>
              <Img src={aboutZombie2} />
            </ImgWrap>
            <TextWrapper>
              <Heading>How Are They Unique?</Heading>
              <BulletWrapper>
                <Bullet>Generated and Stored 100% on the ethereum blockchain</Bullet>
                <Bullet>Each Bit Monster yields $BRAINZ tokens</Bullet>
                <Bullet>$BRAINZ tokens can be used to reroll specific or all traits of any Bit Monster you own</Bullet>
                <Bullet>$BRAINZ tokens can be used to rename your Bit Monster</Bullet>
                <Bullet>$BRAINZ tokens can be used to potentially mutate traits from one Bit Monster to another</Bullet>
                <Bullet>A chance at an animated on chain NFT</Bullet>
                <Bullet>Check the whitepaper for more! Link in the top right</Bullet>
              </BulletWrapper>            
            </TextWrapper>
          </AboutRow>
        </AboutWrapper>
      </AboutContainer>
    </>
  )
}

export default AboutSection
